import type { DsInputLabelProps } from '@/components/design-system/form/input/text/text-input.types';
import type { DsTooltipProps } from '@/components/design-system/tooltip/tooltip.types';
import type { HelperMessageEmits, HelperMessageInputProps } from '@/components/design-system/utils/helper-message.types';

export interface DsMultiSelectOptionBase<T extends string | number = string | number> {
    id: string | number;
    value: T;
    label: string;
    tooltipText?: DsTooltipProps['tooltipText'];
    disabled?: boolean;
}

export interface DsMultiSelectGroup<T> {
    label: string;
    items: T[];
}

export interface DsMultiSelectSlotProps<T> {
    option: T & DsMultiSelectOptionBase;
    isSelected: boolean;
}

export type DsMultiSelectEmits<T> = HelperMessageEmits & {
    'update:modelValue': [value: T[]];
    open: [];
    close: [];
    toggleOption: [payload: { option: T & DsMultiSelectOptionBase; selected: boolean }];
    search: [value: string];
};

export interface DsMultiSelectGroupedOption<T> {
    label?: string;
    items: (T & DsMultiSelectOptionBase)[];
}

export interface DsMultiSelectProps<T> extends HelperMessageInputProps {
    id: string;
    label?: string;
    options: (DsMultiSelectOptionBase & T)[];
    placeholder: string;
    modelValue: T[];
    groupLabel?: string | keyof (DsMultiSelectOptionBase & T);
    searchInputPlaceholder?: string;
    required?: boolean;
    isFullWidth?: boolean;
    disabled?: boolean;
    disableSelectAll?: boolean;
    showSelectAll?: boolean;
    labelTooltip?: DsInputLabelProps['labelTooltip'];
    maxVisibleChips?: number;
    showSelectionCounterOnOverflow?: boolean;
}

export interface DsMultiSelectOptionProps {
    isSelected: boolean;
    disabled?: boolean;
}

export enum SelectAllState {
    Unchecked = 'unchecked',
    Checked = 'checked',
    Indeterminate = 'indeterminate',
}
